<template>
  <div v-if="modalActive" class="overlay" @click.self="$emit('cerrar-modal')">
    <div class="mmc-box">

      <!-- Cabecera -->
      <div class="mmc-header">
        <span class="mmc-title">
          <i class="fab fa-meta me-2" style="color:#1877f2"></i>
          Meta Ads — <span class="text-muted" style="font-weight:400;font-size:.9em">{{ landingNombre }}</span>
        </span>
        <button class="mmc-close" @click="$emit('cerrar-modal')"><i class="fa fa-times"></i></button>
      </div>

      <div class="mmc-body">

        <!-- Campañas existentes -->
        <div v-if="campanasExistentes.length" class="mmc-section mb-3">
          <p class="mmc-label">Campañas creadas</p>
          <div v-for="c in campanasExistentes" :key="c.id">
            <div class="mmc-camp-row">
              <div class="mmc-camp-info">
                <span class="mmc-camp-name">{{ c.campaign_name }}</span>
                <span class="mmc-camp-badge" :class="'mmc-badge--' + c.sync_status">
                  {{ syncLabel(c.sync_status) }}
                </span>
                <span v-if="c.meta_ad_id" class="mmc-camp-badge mmc-badge--ad" title="Ad creado">
                  <i class="fa fa-film me-1" style="font-size:.7em"></i>Ad
                </span>
              </div>
              <div class="mmc-camp-actions">
                <a v-if="c.ads_manager_url" :href="c.ads_manager_url" target="_blank" class="btn btn-sm btn-outline-primary me-1">
                  <i class="fab fa-meta me-1"></i>Abrir Meta
                </a>
                <button v-if="c.sync_status === 'created'" class="btn btn-sm btn-outline-secondary me-1"
                  @click="toggleDuplicar(c)" :class="{ active: duplicandoId === c.id }">
                  <i class="fa fa-copy me-1"></i>+ Ad Set
                </button>
                <button v-if="c.sync_status === 'failed' && c.meta_campaign_id && !c.meta_adset_id"
                  class="btn btn-sm btn-warning" @click="retryAdset(c)" :disabled="retrying === c.id">
                  <i class="fa fa-redo me-1"></i>Reintentar
                </button>
              </div>
            </div>

            <!-- Sub-formulario duplicar Ad Set -->
            <div v-if="duplicandoId === c.id" class="mmc-dup-form">
              <p class="mmc-label mt-2">Nuevo Ad Set dentro de la misma Campaign</p>

              <div class="mmc-field">
                <label>Nombre del Ad Set</label>
                <input v-model="dupForm.adset_name" type="text" class="form-control" :placeholder="c.campaign_name + ' - Ad Set 2'" maxlength="200" />
              </div>

              <div class="mmc-row-2">
                <div class="mmc-field">
                  <label>País objetivo</label>
                  <select v-model="dupForm.country" class="form-select" @change="onDupCountryChange">
                    <option v-for="p in paises" :key="p.value" :value="p.value">{{ p.label }}</option>
                  </select>
                </div>
                <div class="mmc-field">
                  <label>Tipo presupuesto</label>
                  <select v-model="dupForm.budget_type" class="form-select">
                    <option value="daily">Diario</option>
                    <option value="lifetime">Total</option>
                  </select>
                </div>
              </div>

              <div class="mmc-field">
                <label>Importe (€)</label>
                <input v-model.number="dupForm.budget_amount" type="number" min="1" step="0.01" class="form-control" />
              </div>

              <!-- Vídeo en duplicado -->
              <div class="mmc-field">
                <label>Vídeo</label>
                <div class="mmc-video-opts">
                  <label class="mmc-radio">
                    <input type="radio" v-model="dupForm.reutilizar_video" :value="true" />
                    Reutilizar vídeo original
                    <span v-if="c.meta_video_id" class="text-muted ms-1" style="font-size:.75em">({{ c.meta_video_id }})</span>
                  </label>
                  <label class="mmc-radio">
                    <input type="radio" v-model="dupForm.reutilizar_video" :value="false" />
                    Subir nuevo vídeo
                  </label>
                </div>
                <input v-if="!dupForm.reutilizar_video" type="file" accept="video/mp4,video/quicktime,video/avi"
                  class="form-control mt-2" @change="e => dupForm.videoFile = e.target.files[0]" />
              </div>

              <!-- Copy -->
              <div class="mmc-field">
                <label>Texto principal</label>
                <textarea v-model="dupForm.ad_primary_text" class="form-control" rows="3" maxlength="2000"></textarea>
              </div>
              <div class="mmc-field">
                <label>Título</label>
                <input v-model="dupForm.ad_headline" type="text" class="form-control" maxlength="255" />
              </div>

              <div v-if="dupError" class="alert alert-danger mt-1 mb-2" style="font-size:.83em">
                <i class="fa fa-exclamation-triangle me-1"></i> {{ dupError }}
              </div>

              <div class="d-flex justify-content-end gap-2 mt-2">
                <button type="button" class="btn btn-sm btn-secondary" @click="duplicandoId = null">Cancelar</button>
                <button type="button" class="btn btn-sm btn-primary" @click="duplicarAdset(c)" :disabled="duplicando">
                  <span v-if="duplicando"><i class="fa fa-spinner fa-spin me-1"></i>Creando…</span>
                  <span v-else><i class="fa fa-copy me-1"></i>Crear Ad Set</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Separador -->
        <hr v-if="campanasExistentes.length" />

        <!-- Formulario nueva campaña -->
        <p class="mmc-label">{{ campanasExistentes.length ? 'Crear otra campaña' : 'Crear campaña en Meta' }}</p>

        <div v-if="cargandoOpciones" class="text-center py-3">
          <i class="fa fa-spinner fa-spin"></i> Cargando opciones…
        </div>

        <form v-else @submit.prevent="crear">

          <!-- Nombre -->
          <div class="mmc-field">
            <label>Nombre de campaña</label>
            <input v-model="form.campaign_name" type="text" class="form-control" placeholder="TIPSTER_ES_PREMIUM_202609" required maxlength="200" />
          </div>

          <!-- Objetivo -->
          <div class="mmc-field">
            <label>Objetivo</label>
            <select v-model="form.objective" class="form-select" required>
              <option v-for="o in objetivos" :key="o.key" :value="o.key">{{ o.label }}</option>
            </select>
          </div>

          <!-- Presupuesto -->
          <div class="mmc-row-2">
            <div class="mmc-field">
              <label>Tipo presupuesto</label>
              <select v-model="form.budget_type" class="form-select">
                <option value="daily">Diario</option>
                <option value="lifetime">Total</option>
              </select>
            </div>
            <div class="mmc-field">
              <label>Importe (€)</label>
              <input v-model.number="form.budget_amount" type="number" min="1" step="0.01" class="form-control" required />
            </div>
          </div>

          <!-- País -->
          <div class="mmc-field">
            <label>País objetivo</label>
            <select v-model="form.country" class="form-select" @change="onCountryChange">
              <option v-for="p in paises" :key="p.value" :value="p.value">{{ p.label }}</option>
            </select>
          </div>

          <!-- Fechas -->
          <div class="mmc-row-2">
            <div class="mmc-field">
              <label>Fecha y hora inicio</label>
              <input v-model="form.starts_at" type="datetime-local" class="form-control" />
            </div>
            <div class="mmc-field">
              <label>Fecha y hora fin <span class="text-muted">(opcional)</span></label>
              <input v-model="form.ends_at" type="datetime-local" class="form-control" />
            </div>
          </div>

          <!-- Pixel -->
          <div v-if="pixeles.length" class="mmc-field">
            <label>Pixel / Dataset <span class="text-muted">(opcional)</span></label>
            <select v-model="form.meta_pixel_id" class="form-select">
              <option value="">— Sin pixel —</option>
              <option v-for="p in pixeles" :key="p.id" :value="p.id">{{ p.name }} ({{ p.id }})</option>
            </select>
          </div>

          <!-- Attribution spec -->
          <div v-if="attributionSpecs.length" class="mmc-field">
            <label>Ventana de atribución</label>
            <select v-model="form.attribution_spec" class="form-select">
              <option v-for="a in attributionSpecs" :key="a.key" :value="a.key">{{ a.label }}</option>
            </select>
          </div>

          <!-- Sección vídeo y copy -->
          <hr class="my-3" />
          <p class="mmc-label">Vídeo y copy del anuncio <span class="text-muted" style="font-size:.85em;text-transform:none">(opcional — se puede añadir después)</span></p>

          <div class="mmc-field">
            <label>Vídeo <span class="text-muted">(MP4/MOV, máx 50 MB)</span></label>
            <input type="file" accept="video/mp4,video/quicktime,video/avi" class="form-control"
              @change="e => form.videoFile = e.target.files[0]" />
            <div v-if="form.videoFile" class="mt-1 text-muted" style="font-size:.78em">
              <i class="fa fa-film me-1"></i>{{ form.videoFile.name }} ({{ (form.videoFile.size / 1024 / 1024).toFixed(1) }} MB)
            </div>
          </div>

          <div class="mmc-field">
            <label>Texto principal <span class="text-muted">(copy del anuncio)</span></label>
            <textarea v-model="form.ad_primary_text" class="form-control" rows="3" maxlength="2000" :placeholder="copyPlaceholder.primary_text"></textarea>
          </div>

          <div class="mmc-field">
            <label>Título del anuncio</label>
            <input v-model="form.ad_headline" type="text" class="form-control" maxlength="255" :placeholder="copyPlaceholder.headline" />
          </div>

          <!-- Error -->
          <div v-if="errorMsg" class="alert alert-danger mt-2 mb-2" style="font-size:.85em">
            <i class="fa fa-exclamation-triangle me-1"></i> {{ errorMsg }}
          </div>

          <!-- Botones -->
          <div class="mmc-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('cerrar-modal')">Cancelar</button>
            <button type="submit" class="btn btn-primary ms-2" :disabled="creando">
              <span v-if="creando"><i class="fa fa-spinner fa-spin me-1"></i>{{ estadoCreacion }}</span>
              <span v-else><i class="fab fa-meta me-1"></i>Crear en Meta (PAUSED)</span>
            </button>
          </div>

        </form>

        <!-- Resultado exitoso -->
        <div v-if="resultado" class="mmc-resultado">
          <i class="fa fa-check-circle text-success me-2"></i>
          <strong>Campaña creada correctamente</strong>
          <div class="mt-2 text-muted" style="font-size:.85em">
            Campaign ID: <code>{{ resultado.meta_campaign_id }}</code><br>
            Ad Set ID: <code>{{ resultado.meta_adset_id }}</code>
            <span v-if="resultado.meta_ad_id"><br>Ad ID: <code>{{ resultado.meta_ad_id }}</code></span>
          </div>
          <a :href="resultado.ads_manager_url" target="_blank" class="btn btn-outline-primary mt-3 btn-sm">
            <i class="fab fa-meta me-1"></i> Abrir en Meta Ads Manager
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/apiClient';

const COPY_TEMPLATES = {
  es: {
    primary_text: '¿Quieres acceder a los mejores pronósticos deportivos? Únete ahora al canal VIP y recibe picks diarios con alto porcentaje de acierto. 🏆',
    headline:     'Accede al canal VIP de pronósticos',
  },
  en: {
    primary_text: 'Want access to the best sports predictions? Join our VIP channel now and get daily picks with high accuracy. 🏆',
    headline:     'Join the VIP predictions channel',
  },
};

const MERCADOS_EN = ['US', 'CA', 'AU', 'GB'];

function idiomaPorPais(iso) {
  return MERCADOS_EN.includes((iso || '').toUpperCase()) ? 'en' : 'es';
}

export default {
  name: 'ModalMetaCampana',
  emits: ['cerrar-modal', 'campaña-creada'],

  props: {
    modalActive:       { type: Boolean, default: false },
    landingId:         { type: Number,  default: 0 },
    productoLandingId: { type: Number,  default: 0 },
    landingNombre:     { type: String,  default: '' },
    tipsterNombre:     { type: String,  default: '' },
    landingMercado:    { type: String,  default: '' }, // pre-carga desde CampanaLanding.mercado
  },

  data() {
    return {
      cargandoOpciones: false,
      objetivos:        [],
      attributionSpecs: [],
      pixeles:          [],
      campanasExistentes: [],
      retrying: null,

      paises: [
        { value: 'ES', label: 'España' },
        { value: 'MX', label: 'México' },
        { value: 'AR', label: 'Argentina' },
        { value: 'US', label: 'Estados Unidos' },
        { value: 'GB', label: 'Reino Unido' },
        { value: 'CA', label: 'Canadá' },
        { value: 'AU', label: 'Australia' },
        { value: 'EC', label: 'Ecuador' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'PT', label: 'Portugal' },
        { value: 'FR', label: 'Francia' },
        { value: 'DE', label: 'Alemania' },
        { value: 'IT', label: 'Italia' },
      ],

      form: {
        campaign_name: '',
        objective:     'OUTCOME_LEADS',
        budget_type:   'daily',
        budget_amount: 10,
        country:       'ES',
        starts_at:     '',
        ends_at:       '',
        meta_pixel_id:    '',
        attribution_spec: '7D_CLICK_1D_VIEW',
        videoFile:        null,
        ad_primary_text:  '',
        ad_headline:      '',
      },

      creando:       false,
      estadoCreacion: 'Creando…',
      errorMsg:      '',
      resultado:     null,

      // Duplicar Ad Set
      duplicandoId: null,
      duplicando:   false,
      dupError:     '',
      dupForm: {
        adset_name:      '',
        country:         'ES',
        budget_type:     'daily',
        budget_amount:   10,
        reutilizar_video: true,
        videoFile:       null,
        ad_primary_text: '',
        ad_headline:     '',
      },
    };
  },

  computed: {
    copyPlaceholder() {
      return COPY_TEMPLATES[idiomaPorPais(this.form.country)];
    },
  },

  watch: {
    modalActive(val) {
      if (val) this.init();
    },
  },

  methods: {
    async init() {
      this.resultado    = null;
      this.errorMsg     = '';
      this.duplicandoId = null;
      this.form.videoFile = null;

      // Pre-cargar país desde mercado de la landing
      if (this.landingMercado) {
        const iso = this.mercadoToIso(this.landingMercado);
        if (iso) this.form.country = iso;
      }

      this.form.campaign_name = this.sugerirNombre();
      const ahora = new Date();
      const pad = n => String(n).padStart(2, '0');
      this.form.starts_at = `${ahora.getFullYear()}-${pad(ahora.getMonth()+1)}-${pad(ahora.getDate())}T${pad(ahora.getHours())}:${pad(ahora.getMinutes())}`;
      this.form.ends_at = '';

      this.cargandoOpciones = true;
      try {
        const campanaParams = this.productoLandingId
          ? { producto_landing_id: this.productoLandingId }
          : { campana_landing_id: this.landingId };
        const [opts, camps] = await Promise.all([
          api.get('/api/v2/meta/campaigns/options'),
          api.get('/api/v2/meta/campaigns', { params: campanaParams }),
        ]);
        this.objetivos          = opts.data.objetivos         || [];
        this.attributionSpecs   = opts.data.attribution_specs || [];
        this.pixeles            = opts.data.pixeles           || [];
        this.campanasExistentes = camps.data.campanas         || [];
      } catch (e) {
        const status = e?.response?.status;
        if (status === 403) {
          this.errorMsg = 'Sin permiso para gestionar campañas Meta.';
        } else {
          this.errorMsg = e?.response?.data?.mensaje || e?.response?.data?.message || 'No se pudieron cargar las opciones de Meta.';
        }
      } finally {
        this.cargandoOpciones = false;
      }
    },

    sugerirNombre() {
      const tip  = (this.tipsterNombre || 'TIPSTER').toUpperCase().replace(/\s+/g, '');
      const pais = this.form.country || 'ES';
      const mes  = new Date().toISOString().slice(0, 7).replace('-', '');
      const base = `${tip}_${pais}_${mes}`;
      const isDev = !window.location.hostname.includes('quanty.')
        || window.location.hostname.includes('-dev.')
        || window.location.hostname.includes('localhost');
      return isDev ? `DEV_NO_ACTIVAR_${base}` : base;
    },

    onCountryChange() {
      // Placeholder se actualiza vía computed; no hace falta hacer nada aquí
    },

    onDupCountryChange() {
      const tpl = COPY_TEMPLATES[idiomaPorPais(this.dupForm.country)];
      if (!this.dupForm.ad_primary_text) this.dupForm.ad_primary_text = tpl.primary_text;
      if (!this.dupForm.ad_headline)     this.dupForm.ad_headline     = tpl.headline;
    },

    mercadoToIso(mercado) {
      const map = { ESP:'ES',USA:'US',CAN:'CA',GRB:'GB',AUS:'AU',ARG:'AR',MEX:'MX',ECU:'EC',SLV:'SV' };
      return map[(mercado||'').toUpperCase()] || (mercado||'').toUpperCase();
    },

    async crear() {
      this.errorMsg = '';

      if (this.form.starts_at && this.form.ends_at && this.form.ends_at <= this.form.starts_at) {
        this.errorMsg = 'La fecha de fin debe ser posterior a la de inicio.';
        return;
      }

      this.creando   = true;
      this.resultado = null;
      this.estadoCreacion = 'Creando…';

      try {
        const idPayload = this.productoLandingId
          ? { producto_landing_id: this.productoLandingId }
          : { campana_landing_id: this.landingId };

        let resp;

        if (this.form.videoFile) {
          this.estadoCreacion = 'Subiendo vídeo…';
          const fd = new FormData();
          Object.entries({ ...idPayload, ...this.form }).forEach(([k, v]) => {
            if (k === 'videoFile') return;
            if (v !== null && v !== undefined && v !== '') fd.append(k, v);
          });
          fd.append('video', this.form.videoFile);
          resp = await api.post('/api/v2/meta/campaigns', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        } else {
          resp = await api.post('/api/v2/meta/campaigns', {
            ...idPayload,
            ...this.form,
            starts_at:     this.form.starts_at || null,
            ends_at:       this.form.ends_at   || null,
            meta_pixel_id: this.form.meta_pixel_id || null,
            videoFile:     undefined,
          });
        }

        this.resultado = resp.data;
        await this.recargarCampanas();
        this.$emit('campaña-creada', resp.data);
      } catch (e) {
        const data = e.response?.data;
        if (data?.errors) {
          const msgs = Object.values(data.errors).flat();
          this.errorMsg = msgs[0] || 'Error de validación.';
        } else {
          this.errorMsg = data?.mensaje || data?.message || 'Error al crear la campaña en Meta.';
        }
      } finally {
        this.creando = false;
      }
    },

    toggleDuplicar(c) {
      if (this.duplicandoId === c.id) {
        this.duplicandoId = null;
        return;
      }
      this.duplicandoId = c.id;
      this.dupError     = '';
      const tpl = COPY_TEMPLATES[idiomaPorPais(c.country)];
      this.dupForm = {
        adset_name:      c.campaign_name + ' - Ad Set 2',
        country:         c.country || 'ES',
        budget_type:     c.budget_type || 'daily',
        budget_amount:   c.budget_amount || 10,
        reutilizar_video: !!c.meta_video_id,
        videoFile:       null,
        ad_primary_text: c.ad_primary_text || tpl.primary_text,
        ad_headline:     c.ad_headline     || tpl.headline,
      };
    },

    async duplicarAdset(campanaOriginal) {
      this.dupError  = '';
      this.duplicando = true;

      try {
        const fd = new FormData();
        const campos = {
          adset_name:      this.dupForm.adset_name,
          country:         this.dupForm.country,
          budget_type:     this.dupForm.budget_type,
          budget_amount:   this.dupForm.budget_amount,
          reutilizar_video: this.dupForm.reutilizar_video ? '1' : '0',
          ad_primary_text: this.dupForm.ad_primary_text,
          ad_headline:     this.dupForm.ad_headline,
        };
        // campana_landing_id del original o nuevo si viene del form
        if (this.landingId) fd.append('campana_landing_id', this.landingId);
        Object.entries(campos).forEach(([k, v]) => {
          if (v !== null && v !== undefined && v !== '') fd.append(k, v);
        });
        if (!this.dupForm.reutilizar_video && this.dupForm.videoFile) {
          fd.append('video', this.dupForm.videoFile);
        }

        await api.post(`/api/v2/meta/campaigns/${campanaOriginal.id}/duplicar-adset`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.duplicandoId = null;
        await this.recargarCampanas();
        this.$emit('campaña-creada', { duplicado: true });
      } catch (e) {
        const data = e.response?.data;
        if (data?.errors) {
          this.dupError = Object.values(data.errors).flat()[0] || 'Error de validación.';
        } else {
          this.dupError = data?.mensaje || data?.message || 'Error al duplicar el Ad Set.';
        }
      } finally {
        this.duplicando = false;
      }
    },

    async retryAdset(c) {
      this.retrying = c.id;
      try {
        await api.post(`/api/v2/meta/campaigns/${c.id}/retry-adset`);
        await this.recargarCampanas();
      } catch (e) {
        alert(e.response?.data?.mensaje || 'Error al reintentar');
      } finally {
        this.retrying = null;
      }
    },

    async recargarCampanas() {
      const campanaParams = this.productoLandingId
        ? { producto_landing_id: this.productoLandingId }
        : { campana_landing_id: this.landingId };
      const resp = await api.get('/api/v2/meta/campaigns', { params: campanaParams });
      this.campanasExistentes = resp.data.campanas || [];
    },

    syncLabel(status) {
      const map = {
        pending:           'Pendiente',
        uploading_video:   'Subiendo vídeo…',
        creating_campaign: 'Creando campaña…',
        campaign_created:  'Campaña creada',
        creating_adset:    'Creando ad set…',
        adset_created:     'Ad Set creado',
        creating_creative: 'Creando creative…',
        creative_created:  'Creative creado',
        creating_ad:       'Creando ad…',
        created:           '✓ Creada',
        failed:            '✗ Error',
      };
      return map[status] || status;
    },
  },
};
</script>

<style scoped>
.mmc-box {
  background: var(--q-surface, #1e1e2e);
  border-radius: 12px;
  width: 540px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,.08);
}
.mmc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid rgba(255,255,255,.08);
}
.mmc-title { font-size: 1em; font-weight: 600; }
.mmc-close { background: none; border: none; color: inherit; opacity: .6; cursor: pointer; font-size: 1.1em; }
.mmc-close:hover { opacity: 1; }

.mmc-body { padding: 20px; overflow-y: auto; flex: 1; }
.mmc-label { font-size: .75em; text-transform: uppercase; letter-spacing: .06em; opacity: .55; margin-bottom: 10px; }

.mmc-camp-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 6px;
  background: rgba(255,255,255,.04);
  margin-bottom: 4px;
  gap: 8px;
  flex-wrap: wrap;
}
.mmc-camp-info { display: flex; align-items: center; gap: 8px; min-width: 0; flex: 1; }
.mmc-camp-name { font-size: .85em; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mmc-camp-badge { font-size: .7em; padding: 2px 7px; border-radius: 10px; white-space: nowrap; }
.mmc-badge--created     { background: #00c84422; color: #00c844; }
.mmc-badge--failed      { background: #ff444422; color: #ff6666; }
.mmc-badge--ad          { background: #1877f222; color: #1877f2; }
.mmc-badge--pending,
.mmc-badge--uploading_video,
.mmc-badge--creating_campaign,
.mmc-badge--campaign_created,
.mmc-badge--creating_adset,
.mmc-badge--adset_created,
.mmc-badge--creating_creative,
.mmc-badge--creative_created,
.mmc-badge--creating_ad { background: #ffa50022; color: #ffa500; }

.mmc-dup-form {
  padding: 12px 14px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: rgba(255,255,255,.02);
  border: 1px solid rgba(255,255,255,.06);
}

.mmc-video-opts { display: flex; flex-direction: column; gap: 6px; }
.mmc-radio { display: flex; align-items: center; gap: 6px; font-size: .85em; cursor: pointer; }
.mmc-radio input { cursor: pointer; }

.mmc-field { margin-bottom: 14px; }
.mmc-field label { display: block; font-size: .78em; opacity: .7; margin-bottom: 4px; }
.mmc-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

.mmc-footer { display: flex; justify-content: flex-end; margin-top: 20px; }

.mmc-resultado {
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  background: rgba(0, 200, 68, .08);
  border: 1px solid rgba(0,200,68,.2);
  text-align: center;
}

@media (max-width: 540px) {
  .mmc-row-2 { grid-template-columns: 1fr; }
}
</style>
